// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"N0-z"};